module.exports = __webpack_public_path__ + "img/20210603.7e4e721f.png";